<template>
    <div class="container">
        <b-row>
            <b-container>
                <h2 class="text-center">
                    {{labels.title}}
                </h2>
            </b-container>
        </b-row>
        <b-row v-if="!isLoading">
            <b-container>
                <div class="col-md-12 d-flex justify-content-end">
                    <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="crearMenu()">
                        <md-icon>add</md-icon>
                    </md-button>
                </div>
                <div class="row col-md-12 justify-content-center mt-3">
                    <b-table
                        :items="listMenus"
                        :fields="fields"
                        hover
                        bordered
                        responsive
                        sticky-header="500px"
                        small
                        class="tblEstandar"
                        head-variant="custom-blue"
                        :per-page="perPage"
                        :current-page="currentPage"
                    >
                        <template #cell(accionEdit)="data">
                            <md-button
                                style="background-color: #e5ac00; width: 30px; height: 30px;"
                                class="md-fab md-primary"
                                @click="editMenu(data.item.id)"
                            >
                                <md-icon>edit</md-icon>
                            </md-button>
                        </template>
                        <template #cell(accionAsoc)="data">
                            <md-button
                                style="background-color: #cd2838; width: 30px; height: 30px;"
                                class="md-fab md-primary"
                                @click="listarRoles(data.item.id)"
                            >
                                <md-icon><font-awesome-icon :icon="['fas', 'user']" size="xs"/></md-icon>
                            </md-button>
                        </template>
                    </b-table>
                    <div class="row col-12 mt-1">
                        <div class="col-10 d-flex justify-content-center">
                            <b-pagination
                                v-model="currentPage"
                                :per-page="perPage"
                                :total-rows="listMenus.length"
                                align="center"
                                size="md"
                                class="custom-pagination"
                            ></b-pagination>
                        </div>
                        <div class="col-2 d-flex justify-content-end">
                            <label class="mr-2 mb-0">Filas por página:</label>
                            <b-form-select
                            v-model="perPage"
                            :options="[5, 10, 50, 100]"
                            size="sm"
                            style="width: 80px;"
                            ></b-form-select>
                        </div>
                    </div>
                </div>
            </b-container>
        </b-row>
        <Crear :modCrearMenu="modCrearMenu" @closeModal="closeModal"/>
        <Editar :modEditarMenu="modEditarMenu" :infoMenu="datosMenu" @closeModal="closeModal"></Editar>
        <AsociaDesasociaRol :modAsociaDesasociaRol="modalRoles" :infoMenu="datosMenu" @closeModal="closeModal"/>
    </div>
</template>
<script>
import Menu from '../../../services/Menu';
import Crear from './Crear.vue';
import Editar from './EditarMenu.vue';
import AsociaDesasociaRol from './AsociaDesasociaRol.vue';

export default {
    name:'AdministradorMenu',
    components:{
        Crear,
        Editar,
        AsociaDesasociaRol
    },
    data: () => ({
        isLoading: false,
        listMenus : [],
        modCrearMenu: false,
        modEditarMenu: false,
        modalRoles: false,
        datosMenu: [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'nombre', label: 'Nombre'},
            { key: 'ruta', label: 'url'},
            { key: 'icono', label: 'Icono'},
            { key: 'orden', label: 'Orden'},
            { key: 'accionEdit', label: 'Editar', thClass: 'text-center', tdClass: 'text-center'},
            { key: 'accionAsoc', label: 'Asociar menú a rol', thClass: 'text-center', tdClass: 'text-center'},
        ],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : "Menús",
                    nombre : "Nombre",
                    ruta : "Url",
                    icono : "Icono",
                    edit : "Editar",
                    rol : "Roles",
                    orden : "Orden",
                }
            }else{
                return {
                    title : "Menu",
                    nombre : "Name",
                    ruta : "Url",
                    icono : "Icon",
                    edit : "Edit",
                    rol : "Role",
                    orden : "Order",
                }
            }
        }
    },
    mounted(){
        Menu.getAllMenu()
        .then((res) => {
            // console.log(res.data)
            this.listMenus = res.data.listMenu
        })
        .catch((err) => {
            console.log(err)
        })
    },
    methods:{
        closeModal(val){
            this.modCrearMenu = val
            this.modEditarMenu = val
            this.modalRoles = val
        },
        crearMenu(){
            this.modCrearMenu = true
        },
        editMenu(idMenu){
            // console.log(idMenu)
            Menu.getMenuById(idMenu)
            .then((res) => {
                // console.log(res.data.menu)
                this.datosMenu = res.data.menu
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.modEditarMenu = true
            })
        },
        listarRoles(idMenu){
            // console.log("LISTAR: ",idMenu)
            Menu.getMenuById(idMenu)
            .then((res) => {
                // console.log(res.data.menu)
                this.datosMenu = res.data.menu
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.modalRoles = true
            })
        }
    }
}
</script>

<style>

</style>
